import React from 'react';
import { Button, Col, Label, Input, Modal, ModalFooter, ModalBody, ModalHeader, Row } from 'reactstrap';
import Name from '../common/Name';
import Address from '../common/Address';
import Phone from '../common/Phone';
import PersonTypes from '../common/LookupDropDown';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getOptions } from '../../utils';


class PersonModal extends React.Component {

    constructor(props) {
        super(props)

        this.state = this.getInitialState(props);
    }

    getInitialState = (props) => ({
        //   personTypeId: props.personTypes.find(x => x.name === 'Program Administrator').lookupId,
        disableAddContactButton: true,
        emails: [],
        addresses: [{ isActive: true, address: { isActive: true } }],
        phones: [{ isActive: true, isPrimary: true, phoneTypeId: props.phoneTypes.length > 0 ? props.phoneTypes[0].lookupId : null, phone: { isActive: true } },
        { isActive: true, phoneTypeId: props.phoneTypes.length > 0 ? props.phoneTypes[0].lookupId : null, phone: { isActive: true } }],
        isActive: true
    });

    handleAdd = () => {
        const phones = []

        new Promise(resolve => {
            this.state.phones.forEach(personPhone => {
                if (personPhone.phone.formattedNumber)
                    phones.push(personPhone);
            });
            resolve();
        }).then(() => {
            this.setState({ phones }, () => {
                this.props.onAdd(this.state);
                this.setState(this.getInitialState(this.props))
            });

            this.props.toggle();
        });
    }

    handleNameOnChange = (name) => {
        this.setState({ ...name });
    }

    handleOnChange = (event) => {
        const { target: { name, value } } = event
        this.setState({ [name]: value });
    };

    handleAddressOnChange = (name, value) => {
        const addresses = this.state.addresses;
        addresses[0].address[name] = value;
        this.setState({ addresses });
    }

    handlePrimaryPhoneOnChange = (phone) => {
        const phones = this.state.phones;
        phones[0].phone = phone;
        this.setState({ phones });
    }

    handleSecondaryPhoneOnChange = (phone) => {
        const phones = this.state.phones;
        phones[1].phone = phone;
        this.setState({ phones });
    }

    setPhoneType = (e) => {
        const { value } = e.target;
        const selectedPhoneType = this.props.phoneTypes.find(e => e.name === value);

        this.setState(prevState => {
            const updatedPhones = [...prevState.phones];
            updatedPhones[0] = {
                ...updatedPhones[0],
                phoneTypeId: selectedPhoneType ? selectedPhoneType.lookupId : null,
                phone: {
                    ...updatedPhones[0].phone,
                },
            };

            return { phones: updatedPhones };
        });
    }

    getTypes = () => {
        const options = [<option key={0} value={''} disabled>Select a Type</option>];

        this.props.phoneTypes && this.props.phoneTypes.forEach((item, index) => {
            options.push(<option key={index + 1} value={item.lookupId}>{item.name}</option>);
        });

        return options;
    }

    handleEmailOnChange = (e) =>
        this.setState({ emails: [{ isActive: true, isPrimary: true, emailAddress: e.target.value }] });

    closeModal = () => {
        this.props.toggleValidState(false);
        this.setState(this.getInitialState(this.props));
        this.props.toggle();
    }

    render() {
        const { contactNameIsValid } = this.props;
        const reguarExp = new RegExp('[^@ \t\r\n]+@[^@ \t\r\n]+.[^@ \t\r\n]+');
        const markEmailAsInvalid = this.state.emails[0]?.emailAddress && reguarExp.test(this.state.emails[0]?.emailAddress) === false
        const personTypesToSend = this.props.personTypes.filter(person => person.name !== "Staff");
        console.log('markasinvalid', markEmailAsInvalid)
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.closeModal}
                size='lg'
            >
                <ModalHeader toggle={this.closeModal}>{this.props.modalTitle}</ModalHeader>
                <ModalBody>
                    <Name
                        {...this.props.person}
                        toggleContactNameValidState={this.props.toggleValidState}
                        properTitles={this.props.properTitles}
                        generations={this.props.generations}
                        onChange={this.handleNameOnChange}
                    />
                    <Row className='mb-1'>
                        <Col>
                            <PersonTypes
                                label='Person Type'
                                name='personTypeId'
                                value={this.state.personTypeId}
                                onChange={this.handleOnChange}
                                lookups={personTypesToSend}
                            />
                        </Col>
                        <Col>
                            <Label>Email:</Label>
                            <Input invalid={markEmailAsInvalid} name='email' valid type='input' onChange={this.handleEmailOnChange} value={this.state.email} >
                            </Input>
                        </Col>
                    </Row>
                    <Row className='mb-1'>
                        <Col>
                            <Label>Phone Type:</Label>
                            <Input name='phoneType' type='select' id='selectPhoneType' onChange={this.setPhoneType}>
                                {this.getTypes()}
                            </Input>
                        </Col>
                        <Col>
                            <Label>*Number:</Label>
                            <Phone
                                id={'primaryPhone'}
                                toggleContactPhoneIsValid={this.props.toggleContactPhoneIsValid}
                                phone={this.state.phones[0] ? this.state.phones[0].phone : {}}
                                onChange={this.handlePrimaryPhoneOnChange}
                            />
                        </Col>
                    </Row>
                    <Row className='mb-1'>
                        <Col>
                            <Label>Phone Type:</Label>
                            <Input name='phoneType' type='select' id='selectPhoneType' onChange={this.setPhoneType}>
                                {this.getTypes()}
                            </Input>
                        </Col>
                        <Col>
                            <Label>Secondary Phone:</Label>
                            <Phone
                                id={'secondaryPhone'}
                                secondaryPhone={true}
                                toggleContactPhoneIsValid={this.props.toggleContactPhoneIsValid}
                                phone={this.state.phones[1] ? this.state.phones[1].phone : {}}
                                onChange={this.handleSecondaryPhoneOnChange}
                            />
                        </Col>
                    </Row>
                    <Address
                        {...this.state.addresses[0].address}
                        onChange={this.handleAddressOnChange}
                        states={this.props.states}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" disabled={contactNameIsValid === false || markEmailAsInvalid === true || this.state.personTypeId === undefined} onClick={this.handleAdd}>Add</Button>{' '}
                    <Button color="secondary" onClick={this.closeModal}>Cancel</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        phoneTypes: state.StaticData.get('phoneTypes').toJS(),
    }
}

export default withRouter(connect(mapStateToProps)(PersonModal));